// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"style_cardContainer__3NJsr","div1":"style_div1__2AvrI","div1Rotate":"style_div1Rotate__1wZgp","div2":"style_div2__36mQa","div2Rotate":"style_div2Rotate__2t1nS"};